import { EmbeddedEvent } from '../../constants';

/**
 * Legacy events that emit only the event name
 * Do not add new events in this format
 */
const legacyEvents = [EmbeddedEvent.LOAD, EmbeddedEvent.SIGN] as const;

export const createEmbeddedContract = (name: EmbeddedEvent, data?: unknown) => {
  if (legacyEvents.includes(name)) return name;

  return ({
    name,
    data,
  });
};

export function sendEmbeddedMessage(eventName: EmbeddedEvent, data?: unknown) {
  const search = new URLSearchParams(window.location.search);
  const contract = createEmbeddedContract(eventName, data);
  const isEmbedded = search.has('embedded');
  const targetOrigin = search.get('origin');

  if (!targetOrigin || !isEmbedded) return;

  window.parent.postMessage(contract, targetOrigin);
}
